import subtract from 'ramda/src/subtract'
import add from 'ramda/src/add'
import equals from 'ramda/src/equals'
import gt from 'ramda/src/gt'

export default ({ width, isMobileRes, dareStatus, assigneeLength }) => {
	const scrollItemBreakpoints = () => {
		if (isMobileRes) {
			return assigneeLength
		}
		if (dareStatus) {
			if (width < 1161) return 3
			if (width < 1281) return 4
			if (width < 1530) return 5
		} else {
			if (width < 1020) return 4
			if (width < 1210) return 5
		}
		return 6
	}
	const fnScroll = scrollItemBreakpoints()
	const scrollItemArrowBreak = () => {
		if (gt(assigneeLength, fnScroll)) return add(1, subtract(assigneeLength, fnScroll))
		return null
	}

	const stepMultiplier = () => {
		if (!isMobileRes) {
			if (gt(fnScroll, 4)) return 1.026
			if (equals(fnScroll, 4)) return 0.89
			if (equals(fnScroll, 3)) return 0.88
		} else {
			if (equals(assigneeLength, 3)) return 0.76
			if (equals(assigneeLength, 2)) return 0.51
		}
		return 1.011
	}

	const dragActive = () => {
		if (isMobileRes && gt(assigneeLength, 1)) return true
		return false
	}
	return {
		scrollItemBreakpoints,
		scrollItemArrowBreak,
		stepMultiplier,
		dragActive,
	}
}
